import {defineStore} from "pinia";

export const useUserStore = defineStore('user', {
    state: () => ({
        user: {},
        users: [],
    }),
    actions: {
        setUser(user) {
            this.user = user
        },
        setUsers(users) {
            this.users = users
        },
        addUser(user) {
            this.users.unshift(user)
        },
        updateUser(user) {
            let index = this.users.findIndex(cl => cl.id === user.id)
            this.users.splice(index, 1, user)
        },
        deleteUser(user) {
            let index = this.users.findIndex(cl => cl.id === user.id)
            this.users.splice(index, 1)
        },
    },
});